import { mapActions, mapGetters } from 'vuex'

import { registerVuexModule } from '@/utils/vuexUtils'

import relatoriosStore from '../../../store'

import relatoriosOperadorStore from '../_store'

import { validateData, validateComputed } from '../_validates'
import {mask} from 'vue-the-mask'

export const relatoriosOperadorMixins = {
  directives: {mask},
  data: () => ({
    showSkeleton: false,
    showSkeletonForm: false,
    selectByDepartament: false,
    operadores: [],
    operadoresAtivos: [],
    todosOperadores: [],
    centrosDeCusto: [],
    departamentos: [],
    departamentosSelecionados: [],
    maiorQue:0,
  }),

  validations: {
    ...validateData,
  },

  computed: {
    ...validateComputed,
    ...mapGetters('relatoriosOperador', ['getCentrosDeCusto']),
    ...mapGetters('relatoriosOperadorStore', ['getAgents', 'getDepartament']),

    todosOperadoresSelecionados() {
      return this.form.operadores.length === this.operadores.length
    },
    algunsOperadoresSelecionados() {
      return this.form.operadores.length > 0 && !this.todosOperadoresSelecionados
    },
    icon() {
      if (this.todosOperadoresSelecionados) return 'mdi-close-box'
      if (this.algunsOperadoresSelecionados) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },

    somenteOperadoresAtivos(){
      return this.operadores.length === this.operadoresAtivos.length
    },

    iconOperadoresAtivos() {
      if (this.somenteOperadoresAtivos) return 'mdi-close-box'
      return 'mdi-checkbox-blank-outline'
    },

    todosCentrosDeCustosSelecionados() {
      return this.form.centrosDeCusto.length === this.centrosDeCusto.length
    },
    algunsCentrosDeCustosSelecionados() {
      return this.form.centrosDeCusto.length > 0 && !this.todosCentrosDeCustosSelecionados
    },
    iconCentroDeCusto() {
      if (this.todosCentrosDeCustosSelecionados) return 'mdi-close-box'
      if (this.algunsCentrosDeCustosSelecionados) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },

    todosDepartamentosSelecionados() {
      return this.departamentosSelecionados.length === this.departamentos.length
    },
    algunsDepartamentosSelecionados() {
      return this.departamentosSelecionados.length > 0 && !this.todosDepartamentosSelecionados
    },
    iconDepartamento() {
      if (this.todosDepartamentosSelecionados) return 'mdi-close-box'
      if (this.algunsDepartamentosSelecionados) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },

    departamentoEhVazio(){
      if(this.operadoresDoDepartamento.length == 0){
        return true
      }else{
        return this.operadoresDoDepartamento.filter(value => value.length !== 0)
      }
    },

    operadoresDoDepartamento(){
      var agents = []
      if(this.departamentosSelecionados !== undefined){
        this.departamentosSelecionados.forEach(id =>{
          this.getDepartament.forEach(departamentos =>{
            if(id == departamentos._id){
              agents.push(departamentos.agentsDepartamento)
            }
          })
        })
      }
      return agents
    },

    departamentosParaAgents(){
      var agents = []
      this.getDepartament.forEach(departament =>{
        departament.agentsDepartamento.forEach(agent =>{
          let teste = {
            text: `${agent.numero} - ${agent.usuario}` ,
            value: agent._id,
          }
          if(!agents.some(e => e.value == agent._id)){
            agents.push(teste)
          }
        })
      })
      return agents;
    }

  },

  async created() {
    this.showSkeletonForm = true;
    registerVuexModule(this.$store, 'relatoriosOperador', relatoriosStore)
    registerVuexModule(this.$store, 'relatoriosOperadorStore', relatoriosOperadorStore)

    await Promise.all([this.buscarOperadores(), this.buscarCentroDeCustosNaApi(), this.listarDepartamento()])

    this.operadores = this.getAgents.map(operador => ({
      value: operador._id,
      text: `${ (!operador.active) ? 
        `${operador.numero} - ${operador.usuario} - Desativado `: 
        `${operador.numero} - ${operador.usuario}`}`,
      // disabled: !operador.active,
    }))
    this.operadoresAtivos = this.getAgents.filter(operador=>operador.active == true).map(operador => ({
          value: operador._id,
          text:`${operador.numero} - ${operador.usuario}`,
    }))
    this.todosOperadores = this.operadores;

    // console.log(this.operadores, this.operadoresAtivos)


    this.centrosDeCusto = this.getCentrosDeCusto.map(centroDeCusto => ({
      text: `${centroDeCusto.codigo} - ${centroDeCusto.description}`,
      value: centroDeCusto.codigo,
    }))

    this.departamentos = this.getDepartament.map(departament =>({
      text: `${departament.codigo} - ${departament.description}`,
      value: departament._id,
    }))

    this.maiorQue =  "00:00:00",

    this.departamentos.sort((a,b) => a.text.localeCompare(b.text, undefined, { numeric: true }));
    
    this.showSkeletonForm = false;
  },

  methods: {
    ...mapActions('relatoriosOperador', ['buscarCentroDeCustosNaApi']),
    ...mapActions('relatoriosOperadorStore', ['buscarOperadores', 'listarDepartamento']),

    toggleCentroDeCustos() {
      this.$nextTick(() => {
        if (this.todosCentrosDeCustosSelecionados) {
          this.form.centrosDeCusto.splice(0)
        } else {
          this.form.centrosDeCusto.splice(0)
          this.form.centrosDeCusto = this.centrosDeCusto.map(centroDeCusto => centroDeCusto.value)
        }
      })
    },

    toggle() {
      this.$nextTick(() => {
        if (this.todosOperadoresSelecionados) {
          this.form.operadores.splice(0)
        } else {
          this.form.operadores.splice(0)
          this.form.operadores = this.operadores.map(operador => operador.value)
        }
      })
    },

    toggleOperadoresAtivos() {
      this.$nextTick(() => {
        if(!this.somenteOperadoresAtivos){
          this.operadores = this.operadoresAtivos;
        }else{
          this.operadores = this.todosOperadores;
        }
      })
    },


    toggleDepartamento(){
      this.$nextTick(() => {
        if (this.todosDepartamentosSelecionados) {
          this.departamentosSelecionados.splice(0)
        } else {
          this.departamentosSelecionados.splice(0)
          this.departamentosSelecionados = this.departamentos.map(departament => departament.value)
        }
      })
    },

    filtraAgentPorDepartamento(departamentoSelected){
      this.form.operadores.splice(0)
      departamentoSelected.forEach(departamento =>{
        departamento.forEach(operadores =>{
          if(!(this.form.operadores == undefined))
          {
            if((this.form.operadores.findIndex(operadorForm => operadorForm === operadores._id)) === -1){
              this.form.operadores.push(operadores._id)
            }
          }
        })
      })
    },

    maiorQueFormer(numero){
      var p = numero.split(':'),
          s = 0, m = 1;
      while (p.length > 0) {
          s += m * parseInt(p.pop(), 10);
          m *= 60;
      }
      return s;
    },

  },

  watch: {
    departamentosSelecionados: function() {
      this.filtraAgentPorDepartamento(this.operadoresDoDepartamento)
    },
    maiorQue(novo) {
      this.form.maiorQue = this.maiorQueFormer(novo)
    },
  },

}
